module.exports = __webpack_public_path__ + "media/mypage/images/top3-badb446b00eeb2019caadba707db3292.jpg";